if (!window.otxScriptsInitialized) {
  window.otxScriptsInitialized = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMarquees();
    initGaleriaProducto();
    initSelectorVariantes();
    initComparadores();
    initCountUp();
  });
}

function initReveal() {
  var elementos = document.querySelectorAll('.otx-reveal, .otx-reveal-stagger');
  if (!elementos.length) return;
  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('otx-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('otx-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  elementos.forEach(function (el) { observer.observe(el); });
}

function initMarquees() {
  document.querySelectorAll('[data-otx-marquee]').forEach(function (wrap) {
    var track = wrap.querySelector('.otx-marquee-track');
    if (!track) return;
    var velocidad = parseFloat(wrap.getAttribute('data-velocidad')) || 40;
    track.innerHTML += track.innerHTML;
    track.style.animationDuration = velocidad + 's';
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-otx-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-otx-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-otx-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!src) return;
      principal.src = src;
      principal.alt = alt;
      minis.forEach(function (m) { m.classList.remove('otx-mini-activa'); });
      mini.classList.add('otx-mini-activa');
    });
  });
}

function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-otx-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-otx-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = form.querySelectorAll('[data-otx-opcion]');
    if (!selects.length) return;
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-otx-precio]');
    var precioComparadoEl = form.querySelector('[data-otx-precio-comparado]');
    var botonEl = form.querySelector('[data-otx-boton-comprar]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioComparadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioComparadoEl.textContent = moneda(variante.compare_at_price);
          precioComparadoEl.style.display = '';
        } else {
          precioComparadoEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (variante.available) {
          botonEl.disabled = false;
          botonEl.textContent = botonEl.getAttribute('data-texto-disponible') || botonEl.textContent;
        } else {
          botonEl.disabled = true;
          botonEl.textContent = botonEl.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initComparadores() {
  document.querySelectorAll('.otx-comparador').forEach(function (comp) {
    var after = comp.querySelector('.otx-comparador-after');
    var handle = comp.querySelector('.otx-comparador-handle');
    if (!after || !handle) return;

    function mover(clientX) {
      var rect = comp.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    var arrastrando = false;
    comp.addEventListener('pointerdown', function (e) { arrastrando = true; mover(e.clientX); });
    window.addEventListener('pointermove', function (e) { if (arrastrando) mover(e.clientX); });
    window.addEventListener('pointerup', function () { arrastrando = false; });
    comp.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches[0]) mover(e.touches[0].clientX);
    }, { passive: true });
  });
}

function initCountUp() {
  var elementos = document.querySelectorAll('[data-otx-countup]');
  if (!elementos.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-otx-countup')) || 0;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.floor(progreso * fin);
        el.textContent = valor.toLocaleString(document.documentElement.lang || 'es');
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toLocaleString(document.documentElement.lang || 'es');
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  elementos.forEach(function (el) { observer.observe(el); });
}
